/**
 * @description 自动import导入所有 api 模块
 */
const modules = {}

const model = require.context('./model', true, /\.js$/)
model.keys().forEach((key) => {
	modules[key.replace(/(\.\/|\.js)/g, '')] = model(key).default
})

const sys = require.context('./model/sys', true, /\.js$/)
sys.keys().forEach((key) => {
	modules[key.replace(/(\.\/|\.js)/g, '')] = sys(key).default
})


export default modules
